import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import { stringToFloat } from 'utils/misc';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      description: yup
        .string()
        .required(t('validationFieldRequired', { name: t('description') })),
      quantity: yup
        .number()
        .required(t('validationFieldRequired', { name: t('quantity') }))
        .transform(stringToFloat)
        .typeError(t('enterAValidNumericValue')),
      hours: yup
        .number()
        .required(t('validationFieldRequired', { name: t('hours') }))
        .transform(stringToFloat)
        .typeError(t('enterAValidNumericValue')),
      unit: yup
        .string()
        .required(t('validationFieldRequired', { name: t('unit') })),
      type: yup
        .string()
        .required(t('validationFieldRequired', { name: t('type') })),
      startDate: yup
        .date()
        .nullable()
        .required(t('validationFieldRequired', { name: t('startDate') })),
      endDate: yup
        .date()
        .nullable()
        .required(t('validationFieldRequired', { name: t('endDate') })),
      function: yup
        .mixed()
        .required(t('validationFieldRequired', { name: t('function') })),
      organizationalUnitId: yup
        .mixed()
        .transform((val) => {
          return val ? val : null;
        })
        .required(t('validationFieldRequired', { name: t('planUnit') }))
    })
    .required();
};

export default getSchema;
